import React from 'react';
import { Redirect } from 'react-router-dom';
import withUser from './withUser';

// Revalider le jeton AVANT de lire quoi que ce soit sur la personne.
//
// Le navigateur ne conserve plus que la session (cf. store.js) : au rechargement d'une
// page, la tranche `user` ne contient ni le nom, ni le rôle, ni l'accès — ils reviennent
// avec la validation du jeton. La barrière principale (protectedRoute) valide déjà au
// montage ; celles des écrans de paiement lisaient l'accès tel quel et, sur un
// rechargement, renvoyaient à l'accueil faute de le trouver. Elles passent par ici.
const withValidatedUser = (Barrier) => {
  class ValidatedUser extends React.Component {
    constructor(props) {
      super(props);
      this.state = { status: 'loading' };
    }

    async componentDidMount() {
      const { user, validateUserToken } = this.props;
      const valid = await validateUserToken(user);
      this.setState({ status: valid ? 'valid' : 'invalid' });
    }

    render() {
      const { status } = this.state;
      if (status === 'loading') return null;
      if (status === 'invalid') return <Redirect to="/login" />;
      // `this.props.user` est relu ici : le magasin vient d'être rafraîchi.
      return <Barrier {...this.props} />;
    }
  }

  return withUser(ValidatedUser);
};

export default withValidatedUser;
